import React from 'react';
import { Box } from '@mui/material';

import { DistanceField } from '@paragon/material';

import { updateProfileJoint } from '../../../../../../store/actions/profileActions';
import { getSingleSelectedItemEntryOrNull } from '../../../../../../store/selectors/getSelectedItemSelector';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';

export function ProfileJointEditor() {
  const dispatch = useAppDispatch();
  const selectedEntry = useAppSelector(getSingleSelectedItemEntryOrNull);

  if (selectedEntry?.type !== 'profileJoint') return null;

  const profileJoint = selectedEntry.item;
  const update = (x: number, y: number) => {
    dispatch(updateProfileJoint(profileJoint, x, y));
  };

  return (
    <Box sx={{ display: 'flex', flex: 1, p: 1, justifyContent: 'space-evenly' }}>
      <DistanceField
        label="X"
        value={profileJoint.location.x}
        onSubmit={(x) => update(x, profileJoint.location.y)}
        sx={{ mx: 1 }}
      />
      <DistanceField
        label="Y"
        value={profileJoint.location.y}
        onSubmit={(y) => update(profileJoint.location.x, y)}
        sx={{ mx: 1 }}
      />
    </Box>
  );
}
